<template>
    <b-modal id="create-contact-modal" title="Create Contact" hide-footer>
        <loading-screen :is-loading="isSaving"></loading-screen>
        <errors :error-list="serverErrors"></errors>

        <!-- Create new contact -->
        <form @submit.prevent="createNewContact">

            <div class="form-group mb-4">
                <label for="firstNameInput">First Name</label>
                <input type="text" v-model="newContact.first_name" id="firstNameInput" class="form-control">
            </div>

            <div class="form-group mb-4">
                <label for="lastNameInput">Last Name</label>
                <input type="text" v-model="newContact.last_name" id="lastNameInput" class="form-control">
            </div>

            <div class="form-group mb-4">
                <label for="emailInput">Email</label>
                <input type="email" v-model="newContact.email" id="emailInput" class="form-control">
            </div>

            <div class="form-group mb-4">
                <label for="phoneInput">Phone</label>
                <input type="tel" v-model="newContact.phone_number" id="phoneInput" class="form-control">
            </div>

            <button type="submit" class="btn btn-itg-dark" :disabled="isSaving"
                    @click.prevent="createNewContact">Create
                Contact
            </button>

        </form>
        <!-- / Create new contact -->
    </b-modal>
</template>

<script>
    import axios from "axios";
    import Forms from "../../../../mixins/Forms";

    export default {
        name: "CreateContactModal",
        data() {
            return {
                isSaving: false,
                serverErrors: [],

                newContact: {
                    first_name: '',
                    last_name: '',
                    email: '',
                    phone_number: ''
                }
            }
        },
        mixins: [Forms],
        methods: {
            selectContact(contact) {
                this.$emit('select-contact', contact);
                this.$bvModal.hide('create-contact-modal');
            },

            createNewContact() {
                let vm = this;
                vm.serverErrors = [];
                vm.isSaving = true;

                axios.post(API_BASE + '/contacts', vm.newContact).then(r => {
                    vm.isSaving = false;
                    vm.newContact = {
                        first_name: '',
                        last_name: '',
                        email: '',
                        phone_number: ''
                    };
                    vm.selectContact(r.data);
                }).catch(e => {
                    console.log(e);
                    vm.isSaving = false;
                    vm.setErrors(e);
                });
            }
        }
    }
</script>

<style scoped>

</style>
